"use client"

import type React from "react"

export interface QRHistoryItem {
  id: string
  type: string
  value: string
  timestamp: number
  preview: string
}

interface QRHistoryProps {
  history: QRHistoryItem[]
  onSelect: (item: QRHistoryItem) => void
  onClear: () => void
}

const QRHistory: React.FC<QRHistoryProps> = ({ history, onSelect, onClear }) => {
  if (history.length === 0) {
    return null
  }

  return (
    <div className="qr-history">
      <div className="history-header">
        <h3>Recent QR Codes</h3>
        <button onClick={onClear} className="clear-history-btn" type="button">
          Clear History
        </button>
      </div>

      <div className="history-items">
        {history.map((item) => (
          <div key={item.id} className="history-item" onClick={() => onSelect(item)}>
            <div className="history-preview">
              <img src={item.preview || "/placeholder.svg"} alt={`QR code for ${item.value}`} />
            </div>
            <div className="history-info">
              <span className="history-type">{item.type}</span>
              <span className="history-value">
                {item.value.substring(0, 20)}
                {item.value.length > 20 ? "..." : ""}
              </span>
              <span className="history-date">{new Date(item.timestamp).toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default QRHistory
